module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/coeur_d_alene_national_forest-e0630061cd6d970e5147ebad146aeae7.jpg";